import { MovieClip } from '@play-co/timestep-core/ui';
import { Container, Texture } from '../../../odie';
import { getMatch2AssetPath } from '../../util/assets';
import { blockPositionView } from '../../util/blockTools';
import { FrameByFrameClip, playAnimationSequence } from '../../util/animation';
import { BarrelBlockProps } from './BarrelBlock';
import { CountBlockOptionDef } from '../../defs/block';

const manifest = () => ({
  movieclip: {
    url: getMatch2AssetPath('blocks/barrel/movieclip'),
    loadMethod: MovieClip.animationLoader,
  },
  all: getMatch2AssetPath('blocks/barrel'),
});

export class BarrelBlockView extends Container {
  private movieclip: MovieClip;
  private sparks: FrameByFrameClip;
  private _count = 0;

  constructor(props: BarrelBlockProps) {
    super();
    blockPositionView(this, props);

    this.movieclip = new MovieClip({
      superview: this.view,
      url: manifest().movieclip.url,
      scale: 0.97,
      defaultAnimation: 'barrell_stage1',
    });

    this.sparks = new FrameByFrameClip({
      superview: this.movieclip,
      centerOnOrigin: true,
      frames: [
        getMatch2AssetPath('blocks/barrel/movieclip/43.png'),
        getMatch2AssetPath('blocks/barrel/movieclip/45.png'),
        getMatch2AssetPath('blocks/barrel/movieclip/47.png'),
        getMatch2AssetPath('blocks/barrel/movieclip/49.png'),
        getMatch2AssetPath('blocks/barrel/movieclip/51.png'),
        getMatch2AssetPath('blocks/barrel/movieclip/53.png'),
        getMatch2AssetPath('blocks/barrel/movieclip/55.png'),
        getMatch2AssetPath('blocks/barrel/movieclip/57.png'),
        getMatch2AssetPath('blocks/barrel/movieclip/59.png'),
      ],
      rate: 30,
      width: 100,
      height: 100,
      canHandleEvents: false,
    });
  }

  public static assets() {
    return Object.values(manifest());
  }

  public get count(): number {
    return this._count;
  }

  public set count(value: number) {
    this._count = value;
    this.updateView();
  }

  private updateView() {
    switch (this._count) {
      case 5:
        this.sparks.hide();
        this.movieclip.updateOpts({ scale: 0.97, y: -3 });
        playAnimationSequence({
          movieclip: this.movieclip,
          animations: ['barrell_stage1'],
          loopLast: false,
        });
        break;
      case 4:
        this.sparks.hide();
        this.movieclip.updateOpts({ scale: 0.97, y: -3 });
        playAnimationSequence({
          movieclip: this.movieclip,
          animations: ['barrell_stage2'],
          loopLast: false,
        });
        break;
      case 3:
        this.sparks.hide();
        this.movieclip.updateOpts({ scale: 0.97, y: -3 });
        playAnimationSequence({
          movieclip: this.movieclip,
          animations: ['barrell_stage3'],
          loopLast: false,
        });
        break;
      case 2:
        this.sparks.show();
        this.sparks.updateOpts({ x: 30, y: -35, scale: 0.7 });
        this.movieclip.updateOpts({ scale: 0.9, y: 1 });
        playAnimationSequence({
          movieclip: this.movieclip,
          animations: ['barrell_stage4'],
          loopLast: false,
        });
        break;
      case 1:
        this.sparks.show();
        this.sparks.updateOpts({ x: 0, y: -30, scale: 1 });
        this.movieclip.updateOpts({ scale: 0.9, y: 1 });
        playAnimationSequence({
          movieclip: this.movieclip,
          animations: ['barrell_stage5'],
          loopLast: false,
        });
        break;
    }
  }
}

export function _createBarrelBlockView(
  props: BarrelBlockProps,
  option: number,
): BarrelBlockView {
  const optionDef = props.options![option] as CountBlockOptionDef;
  const view = new BarrelBlockView(props);
  view.count = optionDef.count;
  return view;
}
